export default __webpack_public_path__ + "static/media/no-cap.ad4440e6.svg";